export default __webpack_public_path__ + "static/media/mobile_beehive_status_2_uk.f8a08199.png";